const apiBaseUrl = import.meta.env.VITE_APP_BASE_API

export const getBaseUrl = (): string => {
	return apiBaseUrl
}
export const devUrl = import.meta.env.PROD ? '' : 'fxApi'
